import React, { Component } from "react";
import { Button, Modal, Grid } from "semantic-ui-react";
import "react-html5-camera-photo/build/css/index.css";
import { connect } from "react-redux";
import { isTabletOrLess } from "utils/isMobile";
import { Field, Formik, Form } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";

class InsuranceModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			scannerReady: false,
			alternativeScannerValue: "",
			scanInputValue: "",
		};
	}

	getScan = () => {
		this.props.submit(this.state.scanInputValue);
		this.props.close();
	};

	handleKeyDown = (event) => {
		const { scanInputValue } = this.state;
		if (event.key === "Enter" && scanInputValue !== "") this.submitAlternativeScanner(scanInputValue);
	};

	render() {
		const { open } = this.props;
		const { scanInputValue } = this.state;

		return (
			<div>
				<Formik
					enableReinitialize
					initialValues={{
						scannedValue: "",
					}}
					onSubmit={() => this.getScan()}
				>
					{(props) => (
						<Modal size={isTabletOrLess ? "small" : "large"} open={open} closeOnEscape={true} closeOnDimmerClick={true} onClose={this.props.close}>
							<Modal.Header>Scanner votre code</Modal.Header>
							<Modal.Content>
								<Form onSubmit={props.handleSubmit}>
									<Grid columns={1}>
										<Grid.Row>
											<Grid.Column>
												<Field
													component={CustomInputTextComponent}
													autoFocus
													autoComplete="off"
													customlabel="Valeur du code scanné"
													type="text"
													name="scannedValue"
													value={scanInputValue}
													onChange={(e) => {
														this.setState({
															scanInputValue: e.target.value,
														});
													}}
													onKeyDown={this.handleKeyDown}
												/>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							</Modal.Content>
							<Modal.Actions>
								<Form>
									<Button
										onClick={(e) => {
											if (e !== undefined) e.preventDefault();
											this.props.close();
										}}
									>
										{" "}
										Annuler
									</Button>
									<Button primary onClick={props.handleSubmit} disabled={scanInputValue === ""}>
										Confirmer
									</Button>
								</Form>
							</Modal.Actions>
						</Modal>
					)}
				</Formik>
			</div>
		);
	}
}

export default connect(null, null)(InsuranceModal);
